import { Fragment } from 'react';
import Link from 'next/link';

type BreadcrumbLink = {
	text: string;
	href?: string;
};

type BreadcrumbsProps = {
	links: BreadcrumbLink[];
};

export default function Breadcrumbs({
	links = []
}: BreadcrumbsProps ) {
	if ( links.length === 0 ) {
		return <></>;
	}

	const linkClass = `breadcrumb inline-block mr-2 font-semibold text-sm`;

	return (
		<div className="mb-10">
			{ links.map( ( link: BreadcrumbLink, index: number ) => (
				<Fragment key={ index }>
					{ link.href ? (
						<Link href={ link.href } className={ `${ linkClass } text-rural-red-900` }>
							{ link.text }
						</Link>
					) : (
						<div className={ `${ linkClass } text-rural-gray-800` }>
							{ link.text }
						</div>
					)}
				</Fragment>
			))}
		</div>
	);
}
